import React from 'react';
import ContentLoader from 'react-content-loader';
import ThemeV2 from '../../../theme';

const SectionLoader = () => {
  return (
    <>
      <ContentLoader
        speed={2}
        width="286"
        height="500"
        backgroundColor={ThemeV2.palette.gray4}
        foregroundColor={ThemeV2.palette.gray3}
      >
        <rect x="16" y="12" rx="4" ry="4" width="272" height="56" />
        <rect x="16" y="76" rx="4" ry="4" width="272" height="400" />
      </ContentLoader>
      <ContentLoader
        speed={2}
        width="286"
        height="500"
        backgroundColor={ThemeV2.palette.gray4}
        foregroundColor={ThemeV2.palette.gray3}
      >
        <rect x="26" y="12" rx="4" ry="4" width="272" height="56" />
        <rect x="26" y="76" rx="4" ry="4" width="272" height="400" />
      </ContentLoader>
    </>
  );
};

export default SectionLoader;

export const TaskLoader = () => {
  return (
    <div>
      <ContentLoader
        speed={2}
        width="100%"
        height={124}
        backgroundColor={ThemeV2.palette.gray4}
        foregroundColor={ThemeV2.palette.gray3}
      >
        <rect x="0" y="0" rx="8" ry="8" width="100%" height="56" />
        <rect x="0" y="64" rx="8" ry="8" width="100%" height="56" />
      </ContentLoader>
    </div>
  );
};
